<template>
  <div class="inner-wrap" />
</template>

<script>
export default {
  middleware: 'personalPage',
  name: 'personalPage',
  layout: 'personal',
  mounted() {
    // this.$router.push('/personal/myboard')
    
    // open editForm when page is loaded
    this.$nuxt.$emit('toggleEditForm');
  }
}
</script>

<style lang="scss" scoped>
.inner-wrap {
  min-height: 50vh;
}

.theme--light.v-list {
  background: transparent;
}

.jobs-row {
  max-width: 934px;
}

.ads-row {
  max-width: 300px;
}

.job-item {
  border-right: 9px solid #f2f0ef;
}

.job-item.preferred {
  border-right: 9px solid $primary;
}

.filter-btn {
  margin: 0;
  margin-left: 14px;
  border: solid 1px #e3e4e6;
  background-color: rgba(46, 40, 36, 0);
  display: inline-flex;
  align-items: center;
  padding: 5px 10px 5px 10px;
  letter-spacing: -1px;
  font-size: 12px;
}

.filter-by-text {
  display: none;
}

.filter-icon {
  display: inline-block;
  margin-left: 6px !important;
}

.filter-icon:before {
  color: #000;
}

.filter-btn:hover {
  border: 1px solid #000;
}

h3 {
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1;
  letter-spacing: -0.9px;
}

.aside-ad {
  background: #3e4a54;
  text-align: center;
}

@media only screen and (min-width: 700px) {
  .filter-by-text {
    display: block;
  }

  .filter-btn {
    margin: 0;
    height: 50px;
    width: 200px;
    margin-left: 14px;
    border: solid 1px #e3e4e6;
    background-color: rgba(46, 40, 36, 0);
    display: inline-flex;
    align-items: center;
    padding: 5px 10px 5px 10px;
    letter-spacing: -1px;
    font-size: 24px;
  }
}

@media screen and (max-width: 1280px) {
  .jobs-row {
    max-width: 100%;
  }

  .ads-row {
    display: none;
  }
}
</style>
